import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const PreviousPapers = () => {
  const [selectedType, setSelectedType] = useState("cie");
  const [selectedSubject, setSelectedSubject] = useState(null);

  const papers = {
    cie: {
      "BlockChain Technologies": [
        {
          title: "CIE 1,2,3",
          fileId: "1Dx3kmZHDiztcRA6scwEQbAcMZlOrwfzN",
        },
      ],  

      "Cryptography": [
        {
          title: "CIE 1,2,3",
          fileId: "1vVnOF_l9_ry0cezyfDcnyw0wf17TwXoR",
        },
      ], 

      "Municipal Solid Waste Management": [
        {
          title: "Question Bank",
          fileId: "https://drive.google.com/file/d/1Qdv_5DEBcSEmY4ZMXjJTSDECCEPZLzsQ/view?usp=drive_link",
        },
      ], 

      "Internet Of Things": [
        {
          title: "CIE 1,2,3",
          fileId: "134HTGerLqFnU2pcmKFvKjcouTZgprQmT",
        },
      ],

      "Cyber Law and Ethics": [
        {
          title: "CIE 1 QB",
          fileId: "1IN3pPOufjbZKgcz-XIjjNwecjQnSJxZ0", 
        },
        {
          title: "CIE 2 QB",
          fileId: "1O5ii7p9eV3e5XYufW2H2eaQJ7-hlfDjS", 
        },
        {
          title: "CIE 3 QB",
          fileId: "13hdJAMsQBQXZZIdiykLA3xojW7LiygUA",
        }, 
      ],

      "Engineering Graphics": [
        {
          title: "CIE 3 QB",
          fileId: "1Zsl5rB18xlTxpqkKfBDFKsF4FX_LM8my",
        },
      ], 
      
      "Software Engineering": [
        {
          title: "CIE 2",
          fileId: "1sP2t_GPdf-VDEGB_c_vwHkDLl_bi2XNq",
        },
      ], 

      "Theory Of Computation": [
        {
          title: "CIE 2 QB",
          fileId: "1HYh3MqXG3vHzXB8zMdPKLYOyr4M5-qvg",
        },
        {
          title: "CIE 3 QB",
          fileId: "1YYpCww1exsReFHB9f0-Lnxd2x_q4m-JE", 
        },
      ], 

      "Computer Architecture": [
        {
          title: "CIE 1,2,3",
          fileId: "1MKStUZa6-81u6Q6pEGqtU604ksNOQnYc",
        },
        {
          title: "CIE 2 QB",
          fileId: "1fURgho1jYOcNOQeAOyOrtfAPtOVFXWjk",
        },
        {
          title: "CIE 3 QB",
          fileId: "1jwhCyCz20sb8OmZ60bcqbWUmvA-ftsEL",
        },
      ],

      "Computer Information and Ethics": [
        {
          title: "CIE 1,2,3",
          fileId: "1XMPeMW5v3a6E0f-bE9tRr7lXXH-w5rhH",
        },
      ],

      "Communication Systems": [
        {
          title: "CIE 1,2,3",
          fileId: "1f_Jvm_hddaCq9Opw4d1xsk82cr5yQ708",
        },
      ],

      "Computer Networks": [
        {
          title: "CIE 1",
          fileId: "1aiclnqrZqcCT82fAnXQ4YWCGd4MpzWUZ", 
        },
        {
          title: "CIE 2",
          fileId: "1qvr2J1B2XDJ2CYT7GtEwZejM59csKlow",
        },
        {
          title: "CIE 3",
          fileId: "10uXZ9fQFAjNUZGOfqgImRwxOtty8YLt1", 
        },
        {
          title: "All Ln QB (SEM)",
          fileId: "1vems4diaP9plv8FhCGkrL9HXk6OLvltQ",
        },
      ],

      "Java OOPS": [
        {
          title: "CIE 1,2,3",
          fileId: "12V5ohJMVBHO93W0GVtNwJePQgdCh7Izp",
        },
      ],
            "Data Structures": [
        {
          title: "CIE 1,2,3",
          fileId: "1sRaHyqonwKqfN_WaHYNy3FU6MR7NmS-y",
        },
      ],
            "Probability and Statistics": [
        {
          title: "CIE 1,2,3", 
          fileId: "14YTdDbglSx41YHOlGIB6rX_5-mwf-8Rv",
        },
      ],

      "Embedded System Design": [
        {
          title: "CIE 1",
          fileId: "1jra2oxTj7vGk58-9qm1lgSqIVOTWACYg",  
        },
        {
          title: "CIE 2",
          fileId: "1IlE_XLZB__xl48eUoJt0d9DkrJtvsX0k", 
        },
        {
          title: "CIE 3",
          fileId: "1ZmWGmq7TXWR9KbhJ8iWCnJj0rxB-nDnU",  
        }, 
        {
          title: "All Ln QB (SEM)",
          fileId: "1iFFwD1fl37VSXurOlX-UUq89UnotLNAe",  
        },
      ],
    },

    sem: {
      "All Subjects (Sem 2)": [
        {
          title: "Semester Nov 2022",
          fileId: "19txxgA8Ysy34sRsw_F428zt9mBiLDhsC",
        },
      ],
      "All Subjects (Sem 3 core CSE)": [
        {
          title: "Semester Nov 2022",
          fileId: "1wmg-Upfie7o_rTMXe545oRug5X1XlBQv",
        },
      ],
      "All Subjects (Sem 5/6/7 CSE/CSD/AIML)": [
        {
          title: "Semester QP",
          fileId: "1dPEw5ZYKXVc9PF6crPPOrTO8UM2akITl",
        },
      ],
      "All Subjects (Sem 6/7 CSE/CSD/AIML)": [
        {
          title: "Semester QP",
          fileId: "1dGQaujEoRqdaEDgj058w-e1-gH2q0nj1",
        },
      ],
      Python: [
        {
          title: "Semester Nov 2022",
          fileId: "1OzWGlSt9VqBsU5zv7lgm0ildaM00yw0M", 
        },
      ],

      "C Programming": [
        {
          title: "Semester Apr 2023",
          fileId: "1ZlGRbkJdwC5ckc1Et5gx244C6pMTgGYC",
        },
      ],

      "Discrete Mathematics": [
        {
          title: "Semester July 2021",
          fileId: "1Ia3HZbAg2rtVcKmbsoB-a9aYKxdYoPns",
        },
       {
          title: "Semester July 2022",
          fileId: "1l8yMZwtMAS-ESSuChwbV_Qm64KK7uY1c",
        },
        {
          title: "All Unit Question Bank",
          fileId: "16hMSRjPGB63m-D0AcawA43IJ_oIorqqx",
        },
      ],

      "Communication Systems": [
        {
          title: "Semester Nov 2022",
          fileId: "1Lk3px1SRBXToNAcE56UazIQl1lY4gf9o", 
        },
                {
          title: "Semester Nov 2023",
          fileId: "1wEC07si8FwtEqY_WCemVX7O-lifbFiNX", 
        },
      ],

      "Computer And Information Ethics": [
        {
          title: "Semester Nov 2023",
          fileId: "1fu1M17Esy5TsmCjaMI0avTLcMHEIh8P2", 
        },
      ],

      "Probability and Statistics": [
        {
          title: "Semester Nov 2023",
          fileId: "1IzVny8D-TJHRWXJXYyiDFSja_P75ZCU-",
        },
      ],

          "Computer Architecture": [
        {
          title: "Semester Nov 2023",
          fileId: "17dDRS9Ld24AxoUe4j4BL0N9sbKz1TwWZ", 
        },
      ],

          "Data Structures": [
        {
          title: "Semester Nov 2023",
          fileId: "1juhfufi_iZb68gecYecQKdsa_McgRQUn", 
        },
      ],

            "DataBase Management System": [
        {
          title: "Semester May 2024",
          fileId: "1kG5HRfmG59IaYtgbr2Oe16JDnCSMmdaG",
        },
      ],
            "Operating System": [
        {
          title: "Semester May 2024",
          fileId: "1eoGEDzDi4rtSjrbuG0rVz1eQHHVbaKfk",
        },
      ],
            "Design and Analysis of Algorithms": [
        {
          title: "Semester May 2024",
          fileId: "1STbG9YlQFXVMoShJxpPnDbRbzhGuuVuu",
        },
      ],
      "Java OOPS": [
        {
          title: "Semester all qps",
          fileId: "1Vom2axhAGRlWb9DWYDHrsiG07w1pmAfu",
        },
      ],
            "Principles of Management": [
        {
          title: "Semester May 2024",
          fileId: "1Vn1IDviwNpCtjKF3rwLXXd_lZyA2PJMx",  
        },
      ],
            "Theory Of Computation": [
        {
          title: "Semester Nov 2024",
          fileId: "1UB1ubWdVB8j5fe-mvcktbSo57jYK8VDy", 
        },
      ],
            "Software Engineering": [
        {
          title: "Semester Nov 2024",
          fileId: "1_Av9govF0e9Qse9jx8MLCMcC-9vbIpSj", 
        },
      ],
            "Embedded System Design": [
        {
          title: "Semester Nov 2024",
          fileId: "1LR5bcCeCKhs09Jxx_T1H6tEiZyrl0aOY", 
        },
      ],
            "Computer Networks": [
        {
          title: "Semester Nov 2024",
          fileId: "13zmZhqnY7IatJdqg5ZqqJtHAjYBrHxvn",
        },
        {
          title: "All Ln QB (SEM)",
          fileId: "1vems4diaP9plv8FhCGkrL9HXk6OLvltQ",
        },
      ],
            "MunicipalSolid Waste Management": [
        {
          title: "Semester May 2025",
          fileId: "1JoHKKjqMvTNSson5p-0AnWl_R-u9SQU_",  
        },
      ],
            "Artificial Intelligence": [
        {
          title: "Semester May 2025",
          fileId: "1NJht_iwnf-BIidbk9_iOAv-6Vyq4tGyl",
        },
      ],
            "Cloud Computing": [
        {
          title: "Semester May 2025",
          fileId: "1wij7a9OFRVqwlqLpLLtj2OKgQnLj0JY8", 
        },
      ],
        "Web Development": [
        {
          title: "Semester Nov 2025",
          fileId: "1HNtsWYfLZZBHYWjzVkw2OBK_2XlkUcjK", 
        },
      ],
            "Principles of Compiler Design": [
        {
          title: "Semester May 2025",
          fileId: "1NUXvyx0fS7rrF3_eBbB68PCwdpRUy2tq", 
        },
      ],
        "Machine Learning": [
        {
        title: "Semester Nov 2022",
        fileId: "1K_7Jh_Te2_F0jOCE6tpOTz-b8AqJHd2c", 
        },
        {
          title: "Semester Nov 2024",
          fileId: "1RqVVJbb-JSQbST9y6l3o9W-JhZbxprlk", 
          },
        {
          title: "Semester May 2025",
          fileId: "1FRqE2WCZMiUjckTB0E4nQbR0HTmZUlSh",
        },
      ],
      "Internet Of Things": [
      {
          title: "Semester Nov 2022",
          fileId: "1dYX4k9O2gyJvmlQCXwCeL8k_mu7daa7a",
        },
        {
          title: "Semester Nov 2025",
          fileId: "12IFilR7pnRdVShCmEBznYnC7JL9QwZmo",
        },
      ],
        "Block chain Technologies": [
        {
          title: "Semester Nov 2022 with arrear qp",
          fileId: "15FKtU2UMg_6q23_wTUlEOomBzKuRlV5V",
        },
      ],
      "Cryptography": [
        {
          title: "Semester Nov 2022 with arrear qp",
          fileId: "1GHT88BqStAm-qODC8Rce8C-zgVauvLeQ",
        },
      ],
            "Renewable Energy Sources": [
        {
          title: "Semester Nov 2025",
          fileId: "1eKhF_fv--7Oiu1t5VLR_tZ2ML2xWG5O_",  
        },
      ],
            "Cyber Law and Ethics": [
        {
          title: "Semester Nov 2025",
          fileId: "1zOmnuY-5dyc4ihgAn3OVBY9xlW0FDU99", 
        },
      ],
    },
  };

  const subjects = Object.keys(papers[selectedType]);
  const [searchQuery, setSearchQuery] = useState("");
  const [paperSearch, setPaperSearch] = useState("");

  const filteredSubjects = subjects.filter((s) =>
    s.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const filteredPapers = selectedSubject
    ? papers[selectedType][selectedSubject].filter((p) =>
        p.title.toLowerCase().includes(paperSearch.toLowerCase())
      )
    : [];

  return (
    <div className="min-h-screen relative overflow-hidden bg-slate-950 p-6">

      {/* Background Glow */}
      <div className="fixed inset-0 -z-10 overflow-hidden">
        <div className="absolute top-20 left-20 w-80 h-80 bg-blue-600 rounded-full blur-[150px] opacity-20"></div>

        <div className="absolute bottom-20 right-20 w-80 h-80 bg-cyan-500 rounded-full blur-[150px] opacity-20"></div>
      </div>

      <div className="max-w-7xl mx-auto">
        <br />

        {/* Title */}
        <motion.h1
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-4xl md:text-4xl font-extrabold text-center mb-10 bg-white bg-clip-text text-transparent"
        >
          Previous Year Question Papers
        </motion.h1>
        <p className="md:text-xl font-extrabold text-center mb-10 bg-white bg-clip-text text-transparent">
          Please verify the semester and academic year before downloading, as the folder contains question papers for multiple semesters and different years.
        </p>


        {/* Toggle Buttons */}
        <div className="flex justify-center gap-4 mb-10">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => {
              setSelectedType("cie");
              setSelectedSubject(null);
            }}
            className={`px-6 py-3 rounded-xl font-medium transition-all duration-300 ${
              selectedType === "cie"
                ? "bg-blue-600 text-white shadow-[0_0_25px_rgba(59,130,246,0.6)]"
                : "bg-white/10 text-white border border-white/10"
            }`}
          >
            CIE Papers
          </motion.button>

          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => {
              setSelectedType("sem");
              setSelectedSubject(null);
            }}
            className={`px-6 py-3 rounded-xl font-medium transition-all duration-300 ${
              selectedType === "sem"
                ? "bg-blue-600 text-white shadow-[0_0_25px_rgba(59,130,246,0.6)]"
                : "bg-white/10 text-white border border-white/10"
            }`}
          >
            Semester Papers
          </motion.button>
        </div>

        {/* Search for Subjects (when folder list shown) */}
        {!selectedSubject && (
          <div className="flex justify-center mb-6">
            <input
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search subjects..."
              className="w-full max-w-lg px-4 py-2 rounded-lg bg-white/10 border border-white/10 text-white placeholder-white/60 focus:outline-none"
            />
          </div>
        )}

        {/* Folder View */}
        <AnimatePresence mode="wait">

          {!selectedSubject && (
            <motion.div
              key="folders"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <h2 className="text-white text-xl font-semibold mb-8">
                Select Subject
              </h2>

              <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">

                {filteredSubjects.map((subject, index) => (
                  <motion.div
                    key={subject}
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                      delay: index * 0.08,
                    }}
                    whileHover={{
                      y: -10,
                      scale: 1.05,
                    }}
                    whileTap={{
                      scale: 0.95,
                    }}
                    onClick={() => setSelectedSubject(subject)}
                    className="cursor-pointer flex flex-col items-center p-5 rounded-2xl
                    bg-white/5 backdrop-blur-md border border-white/10
                    hover:border-blue-500
                    hover:shadow-[0_0_25px_rgba(59,130,246,0.4)]
                    transition-all duration-300"
                  >
                    <motion.div
                      whileHover={{
                        rotate: [-3, 3, -3, 0],
                      }}
                    >
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/716/716784.png"
                        alt="folder"
                        className="w-24 h-24"
                      />
                    </motion.div>

                    <p className="text-white mt-4 text-center font-medium">
                      {subject}
                    </p>
                  </motion.div>
                ))}

              </div>
            </motion.div>
          )}

          {/* Papers View */}
          {selectedSubject && (
            <motion.div
              key="papers"
              initial={{ opacity: 0, x: 60 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -60 }}
              transition={{ duration: 0.4 }}
            >
              <motion.button
                whileHover={{
                  scale: 1.05,
                }}
                whileTap={{
                  scale: 0.95,
                }}
                onClick={() => setSelectedSubject(null)}
                className="mb-8 px-5 py-2 rounded-xl bg-blue-600 text-white"
              >
                ← Back
              </motion.button>

              <h2 className="text-3xl font-bold text-white mb-4">
                {selectedSubject}
              </h2>

              {/* Search within papers for selected subject */}
              <div className="mb-6">
                <input
                  value={paperSearch}
                  onChange={(e) => setPaperSearch(e.target.value)}
                  placeholder="Search papers..."
                  className="w-full max-w-lg px-4 py-2 rounded-lg bg-white/10 border border-white/10 text-white placeholder-white/60 focus:outline-none"
                />
              </div>

              <div className="space-y-4">
                {filteredPapers.map((paper, index) => (
                    <motion.div
                      key={index}
                      initial={{
                        opacity: 0,
                        x: -40,
                      }}
                      animate={{
                        opacity: 1,
                        x: 0,
                      }}
                      transition={{
                        delay: index * 0.1,
                      }}
                      whileHover={{
                        scale: 1.02,
                      }}
                      className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl p-5 flex flex-col md:flex-row md:items-center md:justify-between hover:border-blue-500 hover:shadow-[0_0_20px_rgba(59,130,246,0.3)] transition-all"
                    >
                      <div className="flex items-center gap-4">
                        <motion.span
                          className="text-4xl"
                          whileHover={{
                            rotate: 10,
                          }}
                        >
                          📄
                        </motion.span>

                        <div>
                          <h3 className="text-white text-lg font-medium">
                            {paper.title}
                          </h3>
                        </div>
                      </div>

                      {/* <motion.a
                        whileHover={{
                          scale: 1.05,
                        }}
                        whileTap={{
                          scale: 0.95,
                        }}
                        href={`https://drive.google.com/file/d/${paper.fileId}/view`}
                        target="_blank"
                        rel="noreferrer"
                        className="mt-4 md:mt-0 px-5 py-2 rounded-lg bg-gradient-to-r from-blue-600 to-cyan-500 text-white font-medium text-center"
                      >
                        Open PDF
                      </motion.a> */}

                    <div className="flex gap-3 mt-4 md:mt-0">

                        {/* Open PDF */}
                        <motion.a
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            href={`https://drive.google.com/file/d/${paper.fileId}/view`}
                            target="_blank"
                            rel="noreferrer"
                            className="px-5 py-2 rounded-lg bg-gradient-to-r from-blue-600 to-cyan-500 text-white font-medium text-center"
                        >
                            📄 Open PDF
                        </motion.a>

                        {/* Download PDF */}
                        <motion.a
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            href={`https://drive.google.com/uc?export=download&id=${paper.fileId}`}
                            className="px-5 py-2 rounded-lg bg-gradient-to-r from-green-600 to-emerald-500 text-white font-medium text-center"
                        >
                            ⬇ Download
                        </motion.a>

                        </div>
                    </motion.div>
                  )
                )}
              </div>
            </motion.div>
          )}

        </AnimatePresence>
      </div>
    </div>
  );
};

export default PreviousPapers;